<div class="refresh-button-wrapper">
    <button mat-icon-button color="primary" (click)="refreshClicked($event)">
        <mat-icon>refresh</mat-icon>
    </button>
</div>
